export class ContentSection {
	public static readonly $type: string = "ContentSection";
	public readonly $type: string = ContentSection.$type;

	public id?: number;
	public title: string = "";
	public content: string = "";
}
